<template>
    <page showBackButton>
        <h1>Online KFZ-Begutachtung</h1>
        <ion-card>
            <p>
                <b>Bitte beachten:</b><br />Das zu versichernde KFZ muss
                unbeschädigt bzw. ordnungsgemäß repariert sein. Du entscheidest
                wie du dein Gebraucht-KFZ besichtigen lässt.
            </p>
            <p>
                <b>Online - super einfach und exklusiv bei klickmal</b><br />
                Dein Gebraucht-KFZ muss binnen 10 Tagen ab Versicherungsbeginn
                abfotografiert werden. Gib uns hier deine Mobiltelefonnummer
                bekannt (Festnetznummern werden nicht unterstützt). Du erhältst
                einen Link per SMS, über den du angeleitet Bilder von deinem
                Fahrzeug machen musst. Andernfalls erlischt die vorläufige
                Deckung.
            </p>
            <p>
                <b>Bei einem ARBÖ Prüfzentrum</b><br />
                Ein Gebraucht-KFZ muss binnen 10 Tagen ab Versicherungsbeginn
                bei einem ARBÖ-Prüfzentrum besichtigt werden, andernfalls
                erlischt die vorläufige Deckung.
            </p>
        </ion-card>
        <base-input
            id="msisdn"
            v-model="msisdn"
            type="tel"
            label="Handynummer"
            :mask="{ mask: '+000000000000000' }"
            infoText="Die Handynummer muss im Format +436641234567 eingegeben werden."
            placeholder="+43/Vorwahl/Nummer"
        ></base-input>
        <base-input
            type="email"
            v-model="email"
            label="E-Mail Adresse"
            id="email"
        ></base-input>
        <ion-button expand="block" class="ion-margin-top" @click="submitForm"
            >Absenden</ion-button
        >
    </page>
</template>

<script>
import Page from "@/components/Page";
import BaseInput from "@/components/BaseInput";
import { versicherungVollkaskoMeldungMotionCloud } from "@/api/motionscloud";

export default {
    components: {
        Page,
        BaseInput,
    },
    props: {
        contractId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            msisdn: "",
            email: "",
        };
    },
    mounted() {
        this.setFormData();
        this.$store.cache.dispatch("user/getUserAddress").then(() => {
            this.setFormData();
        });
    },
    methods: {
        setFormData() {
            this.email = this.$store.state.user.details.email;
        },
        submitForm() {
            this.$store.commit("setLoading", true);
            versicherungVollkaskoMeldungMotionCloud({
                msisdn: this.msisdn.substr(1),
                email: this.email,
                vertragsnummer: this.contractId,
            }).then((response) => {
                if (response.data.Status === 200) {
                    this.$ionic.alertController
                        .create({
                            header: "Erfolgreich abgesendet",
                            message:
                                "Du erhältst in Kürze einen Link um die erforderlichen Fotos hochzuladen.",
                            buttons: ["Ok"],
                        })
                        .then((a) => {
                            a.onDidDismiss().then(() => {
                                this.$router.go(-1);
                            });
                            a.present();
                        });
                }
            });
        },
    },
};
</script>

<style></style>
